import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

/**
 * Device-only hides for notifications.
 *
 * `notifications` has no snooze or dismiss columns, so these cannot ride the
 * synced row: a sync-down replaces that row and would bring a dismissed
 * notification back. This slice is not a synced table.
 */
export interface NotificationHide {
  snoozed_until?: string | null;
  dismissed_at?: string | null;
}

export interface NotificationHidesState {
  byId: Record<string, NotificationHide>;
}

const initialState: NotificationHidesState = {
  byId: {},
};

const notificationHidesSlice = createSlice({
  name: 'notificationHides',
  initialState,
  reducers: {
    snoozeNotification: (state, action: PayloadAction<{ id: string, snoozed_until: string }>) => {
      const current = state.byId[action.payload.id] ?? {};
      state.byId[action.payload.id] = { ...current, snoozed_until: action.payload.snoozed_until };
    },
    dismissNotification: (state, action: PayloadAction<{ id: string, dismissed_at: string }>) => {
      const current = state.byId[action.payload.id] ?? {};
      state.byId[action.payload.id] = { ...current, dismissed_at: action.payload.dismissed_at };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { snoozeNotification, dismissNotification } = notificationHidesSlice.actions;

export default notificationHidesSlice.reducer;
